import { useContext } from 'react';

import { ProductContext } from '../../../context/Products/context';
import CustomButton from '../../atoms/custom-button/custom-button';
import FilterGroup from '../../organisms/filter-group/filter-group';

/* eslint-disable-next-line */
type ProductFiltersProps = {
  handleClearFilters: () => void;
  handleSelectFilter: (type: string, value: string, status: boolean) => void;
  handleViewCategories: () => void;
};

export function ProductFilters(props: ProductFiltersProps) {
  const { handleClearFilters, handleSelectFilter, handleViewCategories } =
    props;
  const { state } = useContext(ProductContext);

  const renderFilters = state.categoryFilters
    .map((categoryFilterGroup: any) => {
      return (
        <FilterGroup
          filterItems={categoryFilterGroup.options}
          filterTitle={categoryFilterGroup.type}
          key={categoryFilterGroup.type}
          handleSelectFilter={(type, filterValue, status) =>
            handleSelectFilter(type, filterValue, status)
          }
        />
      );
    })
    .reverse();

  return (
    <>
      <div>{renderFilters}</div>
      <div className="flex flex-col items-start space-y-4 mt-4">
        <button
          onClick={handleClearFilters}
          className="font-MuseoSans100 text-subtitle hover:underline hover:text-primaryBlue"
        >
          Clear Filters
        </button>
        <CustomButton
          buttonText="VIEW OTHER CATEGORIES"
          buttonStyle="bg-primaryGray text-white hover:text-black hover:bg-widgetGray mt-8"
          textStyle="border-white group-hover:border-primaryGray"
          handleClickButton={handleViewCategories}
        />
      </div>
    </>
  );
}

export default ProductFilters;
